import { constants as orderConstants } from 'utils/order';

import { selectors as uiDirectOrderSelectors } from 'state/direct-order/ui';
import { selectors as quoteDirectOrderSelectors } from 'state/direct-order/quote';
import { selectors as repeatedFromDirectOrderSelectors } from 'state/direct-order/repeated-from';
import { selectors as shipmentDirectOrderSelectors } from 'state/direct-order/shipments';

import { selectors as uiDirectOrderRecurringSelectors } from 'state/direct-order-recurring/ui';
import { selectors as quoteDirectOrderRecurringSelectors } from 'state/direct-order-recurring/quote';
import { selectors as repeatedFromDirectOrderRecurringSelectors } from 'state/direct-order-recurring/repeated-from';
import { selectors as shipmentDirectOrderRecurringSelectors } from 'state/direct-order-recurring/shipments';
import { selectors as rangeDirectOrderRecurringSelectors } from 'state/direct-order-recurring/range';
import { selectors as daysDirectOrderRecurringSelectors } from 'state/direct-order-recurring/days';
import { selectors as holidaysDirectOrderRecurringSelectors } from 'state/direct-order-recurring/holidays';

import { selectors as uiMrDistributionSelectors } from 'state/mrDistribution/ui';
import { selectors as uiMrCollectionSelectors } from 'state/mrCollection/ui';

import { selectors as quoteMrDistributionSelectors } from 'state/mrDistribution/quote';
import { selectors as quoteMrCollectionSelectors } from 'state/mrCollection/quote';

import { selectors as repeatedFromMrDistributionSelectors } from 'state/mrDistribution/repeated-from';
import { selectors as repeatedFromMrCollectionSelectors } from 'state/mrCollection/repeated-from';

import { selectors as shipmentMrDistributionSelectors } from 'state/mrDistribution/shipments';
import { selectors as shipmentMrCollectionSelectors } from 'state/mrCollection/shipments';

const ui = {
  [orderConstants.DIRECT_ORDER]: uiDirectOrderSelectors,
  [orderConstants.DIRECT_ORDER_RECURRING]: uiDirectOrderRecurringSelectors,
  [orderConstants.DISTRIBUTION]: uiMrDistributionSelectors,
  [orderConstants.COLLECTION]: uiMrCollectionSelectors,
};

const quote = {
  [orderConstants.DIRECT_ORDER]: quoteDirectOrderSelectors,
  [orderConstants.DIRECT_ORDER_RECURRING]: quoteDirectOrderRecurringSelectors,
  [orderConstants.DISTRIBUTION]: quoteMrDistributionSelectors,
  [orderConstants.COLLECTION]: quoteMrCollectionSelectors,
};

const repeatedFrom = {
  [orderConstants.DIRECT_ORDER]: repeatedFromDirectOrderSelectors,
  [orderConstants.DIRECT_ORDER_RECURRING]:
    repeatedFromDirectOrderRecurringSelectors,
  [orderConstants.DISTRIBUTION]: repeatedFromMrDistributionSelectors,
  [orderConstants.COLLECTION]: repeatedFromMrCollectionSelectors,
};

const shipments = {
  [orderConstants.DIRECT_ORDER]: shipmentDirectOrderSelectors,
  [orderConstants.DIRECT_ORDER_RECURRING]:
    shipmentDirectOrderRecurringSelectors,
  [orderConstants.DISTRIBUTION]: shipmentMrDistributionSelectors,
  [orderConstants.COLLECTION]: shipmentMrCollectionSelectors,
};

const range = {
  [orderConstants.DIRECT_ORDER]: rangeDirectOrderRecurringSelectors,
  [orderConstants.DIRECT_ORDER_RECURRING]: rangeDirectOrderRecurringSelectors,
  [orderConstants.DISTRIBUTION]: rangeDirectOrderRecurringSelectors,
  [orderConstants.COLLECTION]: rangeDirectOrderRecurringSelectors,
};

const days = {
  [orderConstants.DIRECT_ORDER]: daysDirectOrderRecurringSelectors,
  [orderConstants.DIRECT_ORDER_RECURRING]: daysDirectOrderRecurringSelectors,
  [orderConstants.DISTRIBUTION]: daysDirectOrderRecurringSelectors,
  [orderConstants.COLLECTION]: daysDirectOrderRecurringSelectors,
};

const holidays = {
  [orderConstants.DIRECT_ORDER_RECURRING]:
    holidaysDirectOrderRecurringSelectors,
};

export default {
  ui,
  quote,
  repeatedFrom,
  shipments,
  range,
  days,
  holidays,
};
